import React, { useContext, useState } from "react";
import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";
import { Button } from "./../Controls";

const WhyRefinance: React.FunctionComponent<{
  onSubmit?: (value: TypeWhyRefinance) => void;
}> = (props: { onSubmit?: (value: TypeWhyRefinance) => void }) => {
  const loanFormContext = useContext(LoanFormContext);

  const handleSubmit = (value: TypeWhyRefinance) => {
    if (props.onSubmit) props.onSubmit(value);
  };

  return (
    <div>
      <FormStep
        header={<h1 className="heading-main">Why do you want to refinance?</h1>}
      >
        <div className="form-inputs-wrapper">
          <Button
            label="Lower my monthly payment"
            onClick={() => {
              handleSubmit("lower my monthly payment");
            }}
            anim
            block
            active={
              loanFormContext.whyRefinance?.value === "lower my monthly payment"
                ? true
                : false
            }
          />
          <Button
            label="Pay off my mortgage faster"
            onClick={() => {
              handleSubmit("pay off my mortgage faster");
            }}
            anim
            block
            active={
              loanFormContext.whyRefinance?.value ===
              "pay off my mortgage faster"
                ? true
                : false
            }
          />
          <Button
            label="Take cash out of home"
            onClick={() => {
              handleSubmit("take cash out of home");
            }}
            anim
            block
            active={
              loanFormContext.whyRefinance?.value === "take cash out of home"
                ? true
                : false
            }
          />
          <Button
            label="Change my ARM loan to Fixed"
            onClick={() => {
              handleSubmit("change my ARM loan to fixed");
            }}
            block
            anim
            active={
              loanFormContext.whyRefinance?.value ===
              "change my ARM loan to fixed"
                ? true
                : false
            }
          />
          <Button
            label="Browse current mortgage rates"
            onClick={() => {
              handleSubmit("browse current mortgage rates");
            }}
            anim
            block
            active={
              loanFormContext.whyRefinance?.value ===
              "browse current mortgage rates"
                ? true
                : false
            }
          />
        </div>
      </FormStep>
    </div>
  );
};

export type TypeWhyRefinance =
  | "lower my monthly payment"
  | "pay off my mortgage faster"
  | "take cash out of home"
  | "change my ARM loan to fixed"
  | "browse current mortgage rates";

export default WhyRefinance;
